// extracted by mini-css-extract-plugin
export default {"message":"CreationSuccess_message__D2Vnt","actions":"CreationSuccess_actions__IEJMj"};